var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',{staticClass:"total-item"},[_c('span',{staticClass:"text-label"},[_vm._v("Total: ")]),_c('span',[_vm._v(_vm._s(_vm.getAmountTotal)+" ("+_vm._s('+' + _vm.getDifferenceTotal)+")")])])}
var staticRenderFns = []

export { render, staticRenderFns }